/**
 * Strips everything from the first occurrence of -, –, |, (, or / onwards.
 */
export const cleanJobTitle = (title: string): string => {
  if (!title) return "";
  // 1. Replace forward slashes with hyphens to preserve the full title
  // 2. Strip from -, –, |, or ( onwards
  const preserved = title.replace(/\//g, "-");
  const cleaned = preserved.split(/\s*[-–|(]/)[0].trim();
  return cleaned || title;
};

/**
 * Generates a clean, recruiter-friendly filename for CVs.
 * Format: FirstName-LastName-JobTitle-CompanyName.pdf
 */
export const generateCVFilename = (firstName: string, lastName: string, jobTitle: string, company: string): string => {
  // 1. Clean the job title
  let cleanedTitle = cleanJobTitle(jobTitle);
  
  // 2. Prevent name duplication in job title
  const fullName = `${firstName} ${lastName}`.toLowerCase();
  const lowerTitle = cleanedTitle.toLowerCase();
  
  if (lowerTitle.includes(fullName)) {
     cleanedTitle = cleanedTitle.replace(new RegExp(fullName, 'gi'), '').trim();
  } else if (lowerTitle.includes(firstName.toLowerCase()) && lowerTitle.includes(lastName.toLowerCase())) {
     cleanedTitle = cleanedTitle.replace(new RegExp(firstName, 'gi'), '').replace(new RegExp(lastName, 'gi'), '').trim();
  }
  
  // Clean up any weird separators left after name removal
  cleanedTitle = cleanedTitle.replace(/^[-–|(/]+/g, "").replace(/[-–|(/]+$/g, "").trim();

  // 3. Combine parts
  let name = `${firstName}-${lastName}-${cleanedTitle}-${company}`;
  
  // 4. Formatting rules
  name = name
    .replace(/@/g, "")           // Remove @ symbol
    .replace(/[^\w\s-]/g, "")    // Remove special characters
    .replace(/\s+/g, "-")        // Replace spaces with hyphens
    .replace(/-+/g, "-")        // Remove double hyphens
    .replace(/^-+|-+$/g, "");    // Remove leading/trailing hyphens
    
  if (!name || name === ".pdf") {
    name = "CV";
  }
  
  return name + ".pdf";
};
